'use client';

import { sendErrorToBackend } from '@/core/lib/api/main/errorReporter';
import { useEffect } from 'react';

export function ErrorLogger() {
    useEffect(() => {
        const handleError = (event: ErrorEvent) => {
            const { message, filename, lineno, error } = event;
            sendErrorToBackend({
                message,
                file: filename || 'Unknown',
                line: lineno ?? 1,
                stack_trace: error?.stack || 'No stack',
                url: window.location.href,
            });
        };

        const handleRejection = (event: PromiseRejectionEvent) => {
            const reason = event.reason;
            const message = reason instanceof Error ? reason.message : String(reason);
            const stack = reason instanceof Error ? reason.stack || 'No stack' : 'No stack';
            sendErrorToBackend({
                message,
                file: 'Promise rejection',
                line: 1,
                stack_trace: stack,
                url: window.location.href,
            });
        };

        window.addEventListener('error', handleError);
        window.addEventListener('unhandledrejection', handleRejection);

        return () => {
            window.removeEventListener('error', handleError);
            window.removeEventListener('unhandledrejection', handleRejection);
        };
    }, []);

    return null;
}